import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export const useGetCompanySettings = (companyId, enabled = true) => {
    const intl = useIntl();
    return useQuery([SettingsQueryKey.CompanySettings, companyId], () => api.base
        .get('/api/settings/Company', { params: { id: companyId } })
        .then(res => res.data), {
        enabled: !!companyId && enabled,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
